export default __webpack_public_path__ + "static/media/cao-e-gato.265f5a92.png";